/**
 * Root store actions
 */
import _ from 'lodash';
import { getCookie } from '/src/common/cookie-utils.js';
import FileSaver from 'file-saver';
import { nLevelArrayNest } from '/src/common/general-utils.js';

export async function getEntityList({ commit }) {
  try {
    const selected = getCookie('selectedEntity');
    commit('updateSelectedEntity', selected);
    const data = await this.$axios.$get('/api/entitytrees/list/current', {
      timeout: 20 * 1000
    });
    const list = nLevelArrayNest(data, 'id', 'parent');
    const flattenList = data;
    commit('setEntityData', { list, flattenList, selected });
  } catch (e) {
    // Do Nothing. Error does not need to be propagated
  }
}

/**
 *
 * @param {Object} selectedEntity Set selected entity in current session.
 */
export async function updateSelectedEntity({ commit }, selectedEntity) {
  await this.$axios.$post('/api/entitytrees/session', selectedEntity);
  commit('updateSelectedEntity', selectedEntity.id);
}

/**
 * It is used to get the list of packages.
 * @returns {array} List of application packages.
 */
export function getPackageList({ state }, forceUpdate = false) {
  if (state.packageList.length && !forceUpdate) return null;

  return this.$axios.$get('/api/application-packages', { timeout: 30000 }).then((data) => {
    state.packageList = data;
  });
}

export function changeLanguage({ state }, locale) {
  this.vueApp.$nuxt.$i18n.global.locale = locale;
  state.locale = locale;
  if (!state.loadedLanguages) {
    state.loadedLanguages = [];
  }
  state.loadedLanguages.push(locale);
  document.querySelector('html').setAttribute('lang', locale);
}

/**
 * It is used to get last updated timestamp
 */
export async function getLastUpdatedTimeStamps({ state }) {
  await this.$axios
    .$get('/api/lastUpdateTimePreload')
    .then((res) => {
      state.LAST_UPDATE_TIMESTAMPS = res;
    })
    .catch(() => {
      // In case failure of API, seave current timestamp to avoid setting of undefined in URL
      state.LAST_UPDATE_TIMESTAMPS = setDefaultLastTimeStamp(state.LAST_UPDATE_TIMESTAMPS);
    });
}

/**
 * Dowload a selected file
 * @param {String} param1-url link to download from
 * @param {String} param2-fileName file name to downlad as
 */
export const downloadFileByUrl = function (ctx, { url, fileName }) {
  return this.$axios.$get(url, { responseType: 'arraybuffer' }).then((response) => {
    let file = new Blob([response]);
    FileSaver.saveAs(file, fileName);
    return fileName;
  });
};

export const syncLanguages = async function ({ commit, rootState }, isPreload) {
  const availableLanguages = await this.$axios.$get('/api/language', {
    params: {
      fields: ['UUID', 'Language', 'LanguageCode', 'IsBase', 'IsActive'],
      onlyActive: true,
      _t: isPreload ? rootState.LAST_UPDATE_TIMESTAMPS['apiLanguages'] : new Date().getTime()
    }
  });
  commit('updateLanguages', availableLanguages);
};

/**
 * checks force logout for session expire
 */
export const forceLogoutCheck = async function ({ commit }) {
  try {
    const val = await this.$axios.$get('/api/users/forceLogoutCheck');

    commit('setForceLogout', val);
  } catch (e) {
    commit('setForceLogout', 'not-authorized');
  }
};

/**
 * Gets platform theme details
 */
export const getThemeDetails = async function ({ commit }) {
  try {
    const themeData = await this.$axios.$get('/api/theme');
    commit('setPlatformTheme', themeData);
  } catch (e) {
    commit('setPlatformTheme');
  }
};

export function addToast({ state, commit }, toast) {
  commit('setToasts', [...state.toasts, toast]);
}

function setDefaultLastTimeStamp(lastUpdateTimestamps) {
  const preloadApis = ['apiUserdelegatesUsers', 'apiSystemvariablesFront', 'apiLanguages', 'apiLabels'];
  _.each(preloadApis, function (api) {
    lastUpdateTimestamps[api] = lastUpdateTimestamps[api] ? lastUpdateTimestamps[api] : new Date().getTime();
  });
  return lastUpdateTimestamps;
}
